import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

(async () => {

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '') {

  } else {

  }
  ReactDOM.render(
    <App />,
    document.getElementById('root'),
  );
  serviceWorker.unregister();
})();
